import { gql } from "@apollo/client";
import { ButtonBase } from "@mui/material";
import Grid from "atoms/Grid";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import { SPACING } from "helpers/spacings";
import useData from "helpers/useData";
import Section from "molecules/Section";
import React, { useState } from "react";

import ReelCard, { ReelCardFragment } from "./ReelCard";

export const GameOverviewReelsFragment = gql`
  fragment GameOverviewReelsFragment on Game {
    id
  }
`;

export const GameOverviewReelsGamePlayerFragment = gql`
  fragment GameOverviewReelsGamePlayerFragment on GamePlayer {
    person {
      id
      fullNameWithAnonymisation
    }
  }
`;

const INITIAL_COUNT = 6;

function ReelSection({ title, reels }) {
  const [showAll, setShowAll] = useState(false);
  const displayed = showAll ? reels : reels.slice(0, INITIAL_COUNT);
  const hasMore = reels.length > INITIAL_COUNT;

  return (
    <Section title={title}>
      <Grid gridItemWidth="160px">
        {displayed.map((reelView) => (
          <ReelCard key={reelView.id} reelView={reelView} />
        ))}
      </Grid>
      {hasMore && (
        <ButtonBase
          onClick={() => setShowAll((prev) => !prev)}
          style={{
            fontFamily: FONT_FAMILY_GRAPHIK,
            fontSize: "0.8rem",
            fontWeight: 400,
            color: "#9e9e9e",
            padding: `${SPACING} 0`,
          }}
        >
          {showAll ? "Show Less" : `Show More (${reels.length - INITIAL_COUNT} more)`}
        </ButtonBase>
      )}
    </Section>
  );
}

export default function GameOverviewReels({ gamePlayer }) {
  const [data] = useData(
    gql`
      query GameOverviewReels($gamePlayerId: ID!) {
        gamePlayer(id: $gamePlayerId) {
          id
          team {
            id
            name
          }
          playerReelViews {
            id
            ...ReelCardFragment
          }
          gameReelViews {
            id
            ...ReelCardFragment
          }
        }
      }
      ${ReelCardFragment}
    `,
    {
      gamePlayerId: gamePlayer?.id,
    },
    {
      skip: !gamePlayer,
    },
  );

  const playerReels = data?.gamePlayer?.playerReelViews ?? [];
  const gameReels = data?.gamePlayer?.gameReelViews ?? [];

  if (!playerReels.length && !gameReels.length) {
    return null;
  }

  const playerName = gamePlayer?.person?.fullNameWithAnonymisation;
  const teamName = data?.gamePlayer?.team?.name;

  return (
    <>
      {playerReels.length > 0 && (
        <ReelSection title={playerName ? `${playerName}'s Reels` : "Player Reels"} reels={playerReels} />
      )}
      {gameReels.length > 0 && (
        <ReelSection title={teamName ? `${teamName} Game Reels` : "Team Game Reels"} reels={gameReels} />
      )}
    </>
  );
}
